<script>
// Load speperate modules with destructure assign
import {Line, mixins} from 'vue-chartjs'

const {reactiveProp} = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  methods: {
    updateRendering () {
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/charts/LineChart.vue